const focus = {

    trap(element) {
        document.documentElement.classList.add('no-scroll');
        // store element that invoke the trap, usually a button
        this.trigger = document.activeElement;
        const focusable = element.querySelectorAll('select, input, textarea, button, a');

        if (focusable.length === 0) {
            console.warn('No focusable elements found inside the trap element.');
            return;
        }

        this.firstFocusableElement = focusable[0];
        this.lastFocusableElement = focusable[focusable.length - 1];

        // don't know why but without a litle delay the focus don't work
        setTimeout(() => {
            this.firstFocusableElement.focus();
        }, 300);

        this.boundCheck = this.checkTab.bind(this);
        element.addEventListener('keydown', this.boundCheck);
    },

    untrap(element) {
        document.documentElement.classList.remove('no-scroll');
        element.removeEventListener('keydown', this.boundCheck);
        // return focus to the element that invoked the trap
        if (this.trigger) {
            this.trigger.focus();
        }
    },

    checkTab(event) {
        if (event.key !== 'Tab') return;

        if (event.shiftKey) {
            // focus on first focusable element and you pressed tab + shift
            if (document.activeElement === this.firstFocusableElement) {
                event.preventDefault();
                this.lastFocusableElement.focus();
            }
        } else {
            // focus on last focusable element and you pressed tab
            if (document.activeElement === this.lastFocusableElement) {
                event.preventDefault();
                this.firstFocusableElement.focus();
            }
        }
    }
};